// Стрічка «Що нового» клієнтського порталу.
//
// Джерело: API порталу (/news, /news/latest), у базі лише опубліковані модератором в адмінці
// новини з аудиторією client|both (таблиця platform_news, див. news/README.md).
// «Непрочитане» = id останньої новини не збігається зі збереженим у localStorage цього
// пристрою (per-device, як тема чи розмір тексту, бекенд про прочитане не знає).
import { ref } from 'vue'
import { apiRequest } from './apiClient'
import { getValidToken, hasRefreshableSession } from './authService'

const SEEN_KEY = 'newsSeenId'

export const latestNewsId = ref(null)
export const hasUnreadNews = ref(false)
let indexCache = null

function withAuth(options = {}) {
  const token = getValidToken()
  if (!token) {
    if (hasRefreshableSession()) return options
    throw new Error('token_required')
  }
  return { ...options, headers: { ...(options.headers || {}), Authorization: `Bearer ${token}` } }
}

function getSeenId() {
  try {
    return localStorage.getItem(SEEN_KEY)
  } catch {
    return null
  }
}

function recompute() {
  hasUnreadNews.value = !!latestNewsId.value && latestNewsId.value !== getSeenId()
}

// При старті (після входу): лише id останньої опублікованої для крапки на аватарі.
export async function checkLatestNews() {
  try {
    const data = await apiRequest('/news/latest', withAuth())
    latestNewsId.value = data?.latest?.id ? String(data.latest.id) : null
    recompute()
  } catch {
    // Офлайн, немає сесії або ендпоінт ще не задеплоєно: крапку просто не показуємо
  }
}

// Повна стрічка для сторінки «Що нового» (нові зверху, усі мови всередині кожної новини).
export async function fetchNewsEntries() {
  if (indexCache) return indexCache
  const data = await apiRequest('/news', withAuth())
  indexCache = Array.isArray(data?.news) ? data.news : []
  if (!latestNewsId.value && indexCache[0]) {
    latestNewsId.value = String(indexCache[0].id)
    recompute()
  }
  return indexCache
}

// Відкрили сторінку: усе до цієї новини включно вважаємо прочитаним.
export function markNewsSeen(id = latestNewsId.value) {
  if (!id) return
  try {
    localStorage.setItem(SEEN_KEY, String(id))
  } catch {
    // приватний режим: крапка повернеться після перезавантаження, це не помилка
  }
  recompute()
}
